import React from 'react';
import { Container, Typography } from '@mui/material';

const NotFound = () => {
  return (
    <Container>
      <Typography variant="h4" color="error" gutterBottom>
        404 — Page introuvable
      </Typography>
      <Typography variant="body1">
        La page demandée n'existe pas.
      </Typography>
    </Container>
  );
};

export default NotFound;
